import { useState, useEffect, useCallback } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useSchool } from '../contexts/SchoolContext';
import { useAuth } from '../features/auth/hooks/useAuth';

export function useGmailStatus() {
  const { schoolId } = useSchool();
  const { user } = useAuth();
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshCount, setRefreshCount] = useState(0);

  const refresh = useCallback(() => setRefreshCount(c => c + 1), []);

  useEffect(() => {
    if (!schoolId || !user?.uid) {
      setConnected(false);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const docRef = doc(db, 'schools', schoolId, 'gmailConnections', user.uid);
    const unsubscribe = onSnapshot(
      docRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          setConnected(data.status === 'active');
        } else {
          setConnected(false);
        }
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setConnected(false);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [schoolId, user?.uid, refreshCount]);

  return { connected, loading, error, refresh };
}

export default useGmailStatus;
